module.exports = __webpack_public_path__ + "img/member-icon.72d6ba49.svg";